import { toast } from "react-toastify";
import { fetchAddMidSessionSuccess, fetchAddMidSessionFailure } from "./reducer";
import {MID_SESSION } from "../../constants/constants";
import {setSuccessMessage } from "../../toastMessage/action";
import { getMidSession } from "../thunk";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const addMidSession = (jsonObj, setLoading,setModalOpen) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${MID_SESSION}`, 'POST', jsonObj).then((response) => {
        if (!response.error) {
            setLoading(false)
            setModalOpen(false)
            dispatch(fetchAddMidSessionSuccess(response))
            dispatch(getMidSession(setLoading))
            dispatch(setSuccessMessage(true))
        }
        if (response.error) {
            dispatch(fetchAddMidSessionFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    }).catch((errorResp) => { })
}